<template>
  <div class="min-height flex-column justify-content-start align-items-center">
    <van-form class="width-100" @submit="onSubmit">
      <div class="block3 bg-white width-100 br-reg">
        <van-cell-group>
          <div class="width-100 margin-bs flex-row justify-content-spaceBetween align-items-center">
            <div class="width-40 title">
              <p class="fw-mid">评分人信息</p>
            </div>
          </div>
          <van-field v-model="form.name" name="name" label="昵称" input-align="right" readonly />
          <div class="width-100 margin-bs margin-t flex-row justify-content-spaceBetween align-items-center">
            <div class="width-40 title">
              <p class="fw-mid">评分内容</p>
            </div>
          </div>
          <p class="fs-mid darkgrey">您对餐厅整体餐桌餐椅评分是：</p>
          <p style="font-size: 0.7rem; color: #bbb9b9">满意为10分，基本满意7-9分，不满意2-6分</p>
          <van-field
            v-model="score1"
            is-link
            readonly
            name="picker"
            label="餐桌、餐椅"
            placeholder="点击选择评分"
            @click="showPicker1 = true"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="showPicker1" position="bottom">
            <van-picker :show-toolbar="true" :columns="columns1" @confirm="onConfirm1" @cancel="showPicker1 = false" />
          </van-popup>

          <p class="fs-mid darkgrey">您对饭菜、餐具评分是：</p>
          <p style="font-size: 0.7rem; color: #bbb9b9">满意为15分，基本满意11-14分，不满意4-10分</p>
          <van-field
            v-model="score2"
            is-link
            readonly
            name="picker"
            label="饭菜、餐具"
            placeholder="点击选择评分"
            @click="showPicker2 = true"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="showPicker2" position="bottom">
            <van-picker :show-toolbar="true" :columns="columns2" @confirm="onConfirm2" @cancel="showPicker2 = false" />
          </van-popup>

          <p class="fs-mid darkgrey">您对品味、价格评分是：</p>
          <p style="font-size: 0.7rem; color: #bbb9b9">满意为50分，基本满意35-49分，不满意10-35分</p>
          <van-field
            v-model="score3"
            is-link
            readonly
            name="picker"
            label="品味、价格"
            placeholder="点击选择评分"
            @click="showPicker3 = true"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="showPicker3" position="bottom">
            <van-picker :show-toolbar="true" :columns="columns3" @confirm="onConfirm3" @cancel="showPicker3 = false" />
          </van-popup>

          <p class="fs-mid darkgrey">您对着装、态度评分是：</p>
          <p style="font-size: 0.7rem; color: #bbb9b9">满意为15分，基本满意11-14分，不满意4-10分</p>
          <van-field
            v-model="score4"
            is-link
            readonly
            name="picker"
            label="着装、态度"
            placeholder="点击选择评分"
            @click="showPicker4 = true"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="showPicker4" position="bottom">
            <van-picker :show-toolbar="true" :columns="columns4" @confirm="onConfirm4" @cancel="showPicker4 = false" />
          </van-popup>

          <p class="fs-mid darkgrey">您对食堂管理及供餐情况有哪些具体的宝贵意见和建议</p>
          <van-field v-model="form.opinion" name="reportContent" rows="4" autosize label="" type="textarea" placeholder="请输入您的意见和建议" />
          <!--          <p class="fs-mid darkgrey">备注：评分0-100分，70分为合格。</p>-->
        </van-cell-group>
      </div>
      <div class="width-60 textAlign-c" style="margin: 16px 20%">
        <van-button color="rgb(75,75,75)" class="" round block type="primary" native-type="submit"> 提交 </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { add } from '@/api/canteenApi';
import { Toast } from 'vant';
import moment from 'moment';
import * as dd from 'dingtalk-jsapi';
import canteenConfig from '@/config/canteen';

export default {
  name: 'canteenAdd',
  data() {
    return {
      form: {
        dingId: '',
        name: '',
        mobile: '',
        dept: '',
        score: '',
        opinion: '',
        month: ''
      },
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      columns1: ['10', '9', '8', '7', '6', '5', '4', '3', '2'],
      columns2: ['15', '14', '13', '12', '11', '10', '9', '8', '7', '6', '5', '4'],
      columns3: [
        '50',
        '49',
        '48',
        '47',
        '46',
        '45',
        '44',
        '43',
        '42',
        '41',
        '40',
        '39',
        '38',
        '37',
        '36',
        '35',
        '34',
        '33',
        '32',
        '31',
        '30',
        '29',
        '28',
        '27',
        '26',
        '25',
        '24',
        '23',
        '22',
        '21',
        '20',
        '19',
        '18',
        '17',
        '16',
        '15',
        '14',
        '13',
        '12',
        '11',
        '10'
      ],
      columns4: ['15', '14', '13', '12', '11', '10', '9', '8', '7', '6', '5', '4'],
      score1: '',
      score2: '',
      score3: '',
      score4: ''
    };
  },
  created() {
    this.getPreMonth();
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      let that = this;
      dd.ready(function () {
        dd.util.domainStorage.getItem({
          name: canteenConfig.ddStorage.userId, // 存储信息的key值
          onSuccess: function (info) {
            if (info && info.value) {
              that.form.dingId = info.value;
            } else {
              that.$router.push('/canteenIndex');
            }
          },
          onFail: function () {
            that.$router.push('/canteenIndex');
          }
        });
        dd.util.domainStorage.getItem({
          name: canteenConfig.ddStorage.userName, // 存储信息的key值
          onSuccess: function (info) {
            that.form.name = info.value;
          }
        });
      });
    },
    getPreMonth() {
      let starts = moment().startOf('month').subtract(1, 'month').format('YYYY-MM');
      this.form.month = starts;
    },
    jumpTo(e) {
      this.$router.push(e);
    },
    onConfirm1(value) {
      this.score1 = value;
      this.showPicker1 = false;
    },
    onConfirm2(value) {
      this.score2 = value;
      this.showPicker2 = false;
    },
    onConfirm3(value) {
      this.score3 = value;
      this.showPicker3 = false;
    },
    onConfirm4(value) {
      this.score4 = value;
      this.showPicker4 = false;
    },
    onSubmit() {
      let that = this;
      let toast = Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
      this.form.score = parseInt(this.score1) + parseInt(this.score2) + parseInt(this.score3) + parseInt(this.score4);
      add(this.form).then((response) => {
        toast.clear();
        if (response.code == 200) {
          Toast.success('提交成功');
          setTimeout(function () {
            that.$router.push('/canteenIndex');
          }, 1200);
        } else {
          Toast.fail('提交失败，请稍后再试');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/common.css';
.block1 {
  width: 80%;
  height: 0.8rem;
  border-radius: 2rem 2rem 0 0;
  opacity: 0.25;
}
.block2 {
  width: 90%;
  height: 0.8rem;
  border-radius: 2rem 2rem 0 0;
  opacity: 0.4;
}
.block3 {
  padding: 2rem 5%;
  margin-bottom: 3rem;
}
/deep/.van-hairline--top-bottom::after {
  border: none;
}
/deep/.van-cell {
  //background: #fafafa;
  //padding: 6px 16px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  padding: 10px 0;
}
/deep/.van-cell::after {
  border: none;
}
/deep/.van-switch__node {
  width: 1.5em;
  height: 1.5em;
}
/deep/.van-switch {
  width: 1.7em;
}
</style>
